import { gql } from "graphql-tag"

const DELETE_STORE = gql`
  mutation deleteStore($id: ID!) {
    deleteStore(id: $id) {
      status
    }
  }
`

export default DELETE_STORE
